import { theme } from '../../../tailwind.config';

// Mock data for the combined chart (bookings, sales, purchase, profit) - 12 months of 2025
export const trendData = [
  { month: 'Jan 2025', bookings: 120, sales: 2800000, purchase: 1900000, profitPercent: 5 },
  { month: 'Feb 2025', bookings: 180, sales: 3500000, purchase: 2300000, profitPercent: 4 },
  { month: 'Mar 2025', bookings: 250, sales: 5200000, purchase: 3800000, profitPercent: 3 },
  { month: 'Apr 2025', bookings: 320, sales: 6100000, purchase: 4500000, profitPercent: 4 },
  { month: 'May 2025', bookings: 400, sales: 6800000, purchase: 5200000, profitPercent: 5 },
  { month: 'Jun 2025', bookings: 380, sales: 6500000, purchase: 4900000, profitPercent: 4.5 },
  { month: 'Jul 2025', bookings: 420, sales: 7200000, purchase: 5400000, profitPercent: 5.2 },
  { month: 'Aug 2025', bookings: 390, sales: 6900000, purchase: 5100000, profitPercent: 4.8 },
  { month: 'Sep 2025', bookings: 350, sales: 6300000, purchase: 4700000, profitPercent: 4.2 },
  { month: 'Oct 2025', bookings: 410, sales: 7000000, purchase: 5300000, profitPercent: 5 },
  { month: 'Nov 2025', bookings: 440, sales: 7400000, purchase: 5600000, profitPercent: 5.3 },
  { month: 'Dec 2025', bookings: 480, sales: 7800000, purchase: 5900000, profitPercent: 5.5 },
];

// Mock data for pie chart (booking status)
export const statusData = [
  { name: 'completed', value: 58 },
  { name: 'confirmed', value: 334 },
  { name: 'requested', value: 19 },
];

// Colors for the pie chart (from Tailwind config status colors)
export const PIE_COLORS = [
  theme.colors['status-completed'],
  theme.colors['status-confirmed'],
  theme.colors['status-requested'],
]; // status-completed, status-confirmed, status-requested

// Mock data for histogram (bookings vs guests) - individual guest counts
export const histogramData = [
  { guests: '1', bookings: 120 },
  { guests: '2', bookings: 280 },
  { guests: '3', bookings: 190 },
  { guests: '4', bookings: 150 },
  { guests: '5', bookings: 110 },
  { guests: '6', bookings: 85 },
  { guests: '7', bookings: 60 },
  { guests: '8', bookings: 45 },
  { guests: '9', bookings: 30 },
  { guests: '10+', bookings: 50 },
];

// Mock data for box plot (simulated with bars showing quartiles)
export const boxPlotData = [
  { category: 'Q1 (25%)', value: 50 },
  { category: 'Median', value: 100 },
  { category: 'Q3 (75%)', value: 200 },
  { category: 'Outliers', value: 300 },
];

// Mock data for area chart (bookings by arrival date)
export const arrivalData = [
  { date: 'Sep 2025', bookings: 70 },
  { date: 'Oct 2025', bookings: 110 },
  { date: 'Nov 2025', bookings: 90 },
  { date: 'Dec 2025', bookings: 75 },
  { date: 'Jan 2026', bookings: 65 },
  { date: 'Feb 2026', bookings: 50 },
  { date: 'Mar 2026', bookings: 40 },
  { date: 'Apr 2026', bookings: 30 },
  { date: 'May 2026', bookings: 25 },
  { date: 'Jun 2026', bookings: 20 },
  { date: 'Jul 2026', bookings: 15 },
];

// Mock data for heatmap (audience by time) - All 24 hours
export const heatmapData = [
  { time: '00:00 AM', Mon: 1191, Tue: 1208, Wed: 1200, Thu: 1232, Fri: 1234, Sat: 1244, Sun: 1226 },
  { time: '01:00 AM', Mon: 1275, Tue: 1253, Wed: 1216, Thu: 1251, Fri: 1260, Sat: 1245, Sun: 1248 },
  { time: '02:00 AM', Mon: 1300, Tue: 1255, Wed: 1280, Thu: 1291, Fri: 1261, Sat: 1265, Sun: 1220 },
  { time: '03:00 AM', Mon: 1307, Tue: 1317, Wed: 1317, Thu: 1325, Fri: 1367, Sat: 1703, Sun: 1328 },
  { time: '04:00 AM', Mon: 1375, Tue: 1380, Wed: 1391, Thu: 1376, Fri: 1393, Sat: 1367, Sun: 1313 },
  { time: '05:00 AM', Mon: 1406, Tue: 1404, Wed: 1410, Thu: 1425, Fri: 1430, Sat: 1420, Sun: 1373 },
  { time: '06:00 AM', Mon: 1463, Tue: 1465, Wed: 1505, Thu: 1454, Fri: 1438, Sat: 1431, Sun: 1418 },
  { time: '07:00 AM', Mon: 1452, Tue: 1467, Wed: 1467, Thu: 1486, Fri: 1487, Sat: 1463, Sun: 1491 },
  { time: '08:00 AM', Mon: 1490, Tue: 1499, Wed: 1525, Thu: 1490, Fri: 1483, Sat: 1411, Sun: 1462 },
  { time: '09:00 AM', Mon: 1520, Tue: 1495, Wed: 1511, Thu: 1498, Fri: 1473, Sat: 1423, Sun: 1466 },
  { time: '10:00 AM', Mon: 1506, Tue: 1546, Wed: 1496, Thu: 1502, Fri: 1417, Sat: 1399, Sun: 1514 },
  { time: '11:00 AM', Mon: 1446, Tue: 1465, Wed: 1496, Thu: 1447, Fri: 1415, Sat: 1394, Sun: 1460 },
  { time: '12:00 PM', Mon: 1355, Tue: 1393, Wed: 1401, Thu: 1391, Fri: 1338, Sat: 1351, Sun: 1388 },
  { time: '13:00 PM', Mon: 1220, Tue: 1244, Wed: 1210, Thu: 1207, Fri: 1186, Sat: 1204, Sun: 1175 },
  { time: '14:00 PM', Mon: 972, Tue: 994, Wed: 1000, Thu: 959, Fri: 1015, Sat: 977, Sun: 912 },
  { time: '15:00 PM', Mon: 734, Tue: 748, Wed: 745, Thu: 743, Fri: 711, Sat: 704, Sun: 705 },
  { time: '16:00 PM', Mon: 618, Tue: 631, Wed: 595, Thu: 610, Fri: 643, Sat: 650, Sun: 577 },
  { time: '17:00 PM', Mon: 583, Tue: 586, Wed: 565, Thu: 585, Fri: 590, Sat: 567, Sun: 533 },
  { time: '18:00 PM', Mon: 612, Tue: 609, Wed: 605, Thu: 624, Fri: 566, Sat: 533, Sun: 562 },
  { time: '19:00 PM', Mon: 657, Tue: 668, Wed: 664, Thu: 655, Fri: 637, Sat: 608, Sun: 637 },
  { time: '20:00 PM', Mon: 747, Tue: 767, Wed: 752, Thu: 746, Fri: 662, Sat: 651, Sun: 743 },
  { time: '21:00 PM', Mon: 890, Tue: 887, Wed: 866, Thu: 895, Fri: 755, Sat: 711, Sun: 873 },
  { time: '22:00 PM', Mon: 1075, Tue: 1058, Wed: 1073, Thu: 1031, Fri: 939, Sat: 908, Sun: 1047 },
  { time: '23:00 PM', Mon: 1133, Tue: 1128, Wed: 1142, Thu: 1122, Fri: 1069, Sat: 1046, Sun: 1119 },
];

export const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Function to get color based on value for heatmap
export const getHeatmapColor = (value: number): string => {
  if (value >= 1400) return theme.colors['brown-hard']; // brown-hard
  if (value >= 1200) return theme.colors['brown-100']; // brown-100
  if (value >= 1000) return theme.colors['brown-60']; // close to brown-40
  if (value >= 800) return theme.colors['purple']; // purple
  if (value >= 600) return theme.colors['purple']; // purple
  return theme.colors['purple']; // purple
};

// Mock data for scatter plot (hotels by score and reviews) - Extended data
export const hotelScatterData = [
  { reviews: 15, score: 2.8 },
  { reviews: 25, score: 3.0 },
  { reviews: 35, score: 4.1 },
  { reviews: 45, score: 4.3 },
  { reviews: 55, score: 3.6 },
  { reviews: 65, score: 4.5 },
  { reviews: 75, score: 4.2 },
  { reviews: 85, score: 4.7 },
  { reviews: 95, score: 3.9 },
  { reviews: 105, score: 4.4 },
  { reviews: 120, score: 4.4 },
  { reviews: 135, score: 4.6 },
  { reviews: 150, score: 3.8 },
  { reviews: 165, score: 4.5 },
  { reviews: 180, score: 4.6 },
  { reviews: 195, score: 4.3 },
  { reviews: 200, score: 4.8 },
  { reviews: 215, score: 4.7 },
  { reviews: 220, score: 4.5 },
  { reviews: 235, score: 4.6 },
  { reviews: 250, score: 4.7 },
  { reviews: 265, score: 4.4 },
  { reviews: 280, score: 4.9 },
  { reviews: 295, score: 4.5 },
  { reviews: 300, score: 4.6 },
  { reviews: 315, score: 4.7 },
  { reviews: 320, score: 4.8 },
  { reviews: 335, score: 4.6 },
  { reviews: 350, score: 4.7 },
  { reviews: 365, score: 4.8 },
  { reviews: 380, score: 4.9 },
  { reviews: 410, score: 4.6 },
  { reviews: 440, score: 4.7 },
  { reviews: 450, score: 4.5 },
  { reviews: 480, score: 4.8 },
  { reviews: 520, score: 4.6 },
  { reviews: 560, score: 4.7 },
  { reviews: 600, score: 4.5 },
  { reviews: 650, score: 4.4 },
  { reviews: 700, score: 4.6 },
  { reviews: 750, score: 4.5 },
  { reviews: 800, score: 4.7 },
  { reviews: 850, score: 4.3 },
];

// Mock data for stacked area chart (sales by country) - All start from 0
export const salesByCountryData = [
  { month: 'Aug 2024', Oman: 0, UAE: 0, Seychelles: 0, SouthAfrica: 0 },
  { month: 'Sep 2024', Oman: 50, UAE: 30, Seychelles: 20, SouthAfrica: 15 },
  { month: 'Oct 2024', Oman: 120, UAE: 80, Seychelles: 60, SouthAfrica: 40 },
  { month: 'Nov 2024', Oman: 220, UAE: 150, Seychelles: 110, SouthAfrica: 75 },
  { month: 'Dec 2024', Oman: 350, UAE: 250, Seychelles: 180, SouthAfrica: 120 },
  { month: 'Jan 2025', Oman: 420, UAE: 320, Seychelles: 230, SouthAfrica: 160 },
  { month: 'Feb 2025', Oman: 500, UAE: 380, Seychelles: 270, SouthAfrica: 190 },
  { month: 'Mar 2025', Oman: 580, UAE: 450, Seychelles: 320, SouthAfrica: 230 },
  { month: 'Apr 2025', Oman: 680, UAE: 550, Seychelles: 390, SouthAfrica: 280 },
  { month: 'May 2025', Oman: 750, UAE: 620, Seychelles: 450, SouthAfrica: 320 },
  { month: 'Jun 2025', Oman: 820, UAE: 680, Seychelles: 500, SouthAfrica: 360 },
  { month: 'Jul 2025', Oman: 900, UAE: 750, Seychelles: 560, SouthAfrica: 410 },
  { month: 'Aug 2025', Oman: 980, UAE: 810, Seychelles: 610, SouthAfrica: 450 },
];

// Mock data for churn rate chart
export const churnRateData = [
  { month: 'Jan', activePartners: 120, churnedPartners: 5, churnRate: 0.73 },
  { month: 'Feb', activePartners: 125, churnedPartners: 8, churnRate: 1.13 },
  { month: 'Mar', activePartners: 130, churnedPartners: 12, churnRate: 1.95 },
  { month: 'Apr', activePartners: 128, churnedPartners: 10, churnRate: 1.69 },
  { month: 'May', activePartners: 135, churnedPartners: 15, churnRate: 2.14 },
  { month: 'Jun', activePartners: 132, churnedPartners: 18, churnRate: 2.95 },
  { month: 'Jul', activePartners: 140, churnedPartners: 20, churnRate: 3.38 },
  { month: 'Aug', activePartners: 138, churnedPartners: 22, churnRate: 3.02 },
  { month: 'Sep', activePartners: 145, churnedPartners: 25, churnRate: 2.72 },
];

// Mock data for bubble chart (churn by country) - 30 countries with non-overlapping positions
export const churnByCountryData = [
  { country: 'USA', value: 450, x: 50, y: 50, color: theme.colors['red-92'] }, // red-92
  { country: 'UK', value: 380, x: 20, y: 75, color: theme.colors['green-90'] }, // green-90
  { country: 'Russia', value: 280, x: 75, y: 25, color: theme.colors['bright-sky-blue'] }, // bright-sky-blue
  { country: 'Spain', value: 150, x: 15, y: 40, color: theme.colors['yellow-30'] }, // yellow-30
  { country: 'France', value: 200, x: 35, y: 70, color: theme.colors['purple'] }, // purple
  { country: 'Germany', value: 170, x: 85, y: 60, color: theme.colors['inv-teal'] }, // inv-teal
  { country: 'Italy', value: 140, x: 60, y: 15, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Brazil', value: 190, x: 25, y: 30, color: theme.colors['brown-100'] }, // brown-100
  { country: 'Australia', value: 120, x: 70, y: 80, color: theme.colors['gray-100'] }, // gray-100
  { country: 'Canada', value: 220, x: 40, y: 45, color: theme.colors['inv-rose'] }, // inv-rose
  { country: 'Japan', value: 180, x: 80, y: 40, color: theme.colors['bright-sky-blue'] }, // bright-sky-blue
  { country: 'China', value: 310, x: 65, y: 65, color: theme.colors['inv-aqua'] }, // inv-aqua
  { country: 'India', value: 160, x: 90, y: 20, color: theme.colors['inv-yellow'] }, // inv-yellow
  { country: 'Mexico', value: 130, x: 10, y: 60, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Argentina', value: 110, x: 55, y: 85, color: theme.colors['inv-purple'] }, // inv-purple
  { country: 'Netherlands', value: 145, x: 30, y: 55, color: theme.colors['inv-aqua'] }, // inv-aqua
  { country: 'Belgium', value: 125, x: 45, y: 25, color: theme.colors['inv-green'] }, // inv-green
  { country: 'Switzerland', value: 155, x: 20, y: 15, color: theme.colors['red-100'] }, // red-100
  { country: 'Sweden', value: 135, x: 75, y: 75, color: theme.colors['yellow-50'] }, // yellow-50
  { country: 'Norway', value: 115, x: 95, y: 45, color: theme.colors['purple-light'] }, // purple-light
  { country: 'Denmark', value: 105, x: 10, y: 85, color: theme.colors['teal-100'] }, // teal-100
  { country: 'Finland', value: 95, x: 85, y: 10, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Poland', value: 165, x: 60, y: 35, color: theme.colors['gray-80'] }, // gray-80
  { country: 'Portugal', value: 100, x: 35, y: 90, color: theme.colors['gray-100'] }, // gray-100
  { country: 'Greece', value: 90, x: 50, y: 20, color: theme.colors['inv-rose'] }, // inv-rose
  { country: 'Turkey', value: 175, x: 15, y: 50, color: theme.colors['inv-aqua'] }, // inv-aqua
  { country: 'UAE', value: 210, x: 70, y: 55, color: theme.colors['inv-green'] }, // inv-green
  { country: 'South Africa', value: 140, x: 40, y: 80, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Singapore', value: 160, x: 90, y: 70, color: theme.colors['inv-violet'] }, // inv-violet
  { country: 'New Zealand', value: 85, x: 25, y: 10, color: theme.colors['inv-teal'] }, // inv-teal
];

// Mock data for horizontal bar chart (months since last booking) - Grouped by country
export const monthsSinceBookingData = [
  // Belgium
  { country: 'Belgium', company: 'Global Concierge Service', months: 18, color: theme.colors['brown-60'] }, // brown-60
  { country: 'Belgium', company: 'ORIGINAL ESCAPES', months: 12, color: theme.colors['brown-60'] }, // brown-60
  { country: 'Belgium', company: 'ORIGINAL SENSES BV', months: 15, color: theme.colors['brown-60'] }, // brown-60
  { country: 'Belgium', company: 'The Travel Distillery', months: 20, color: theme.colors['brown-60'] }, // brown-60
  { country: 'Belgium', company: 'TOTEM TRAVEL', months: 3, color: theme.colors['brown-60'] }, // brown-60
  { country: 'Belgium', company: 'World Concierge', months: 22, color: theme.colors['brown-60'] }, // brown-60
  // Brazil
  { country: 'Brazil', company: 'Allocation (Brazil) TA', months: 8, color: theme.colors['green-90'] }, // green-90
  { country: 'Brazil', company: 'Auroaravel Viagens', months: 16, color: theme.colors['green-90'] }, // green-90
  { country: 'Brazil', company: 'Duo Network', months: 10, color: theme.colors['green-90'] }, // green-90
  { country: 'Brazil', company: 'ELLYSTUR TURISMO', months: 14, color: theme.colors['green-90'] }, // green-90
  { country: 'Brazil', company: 'Exclusive Frt', months: 4, color: theme.colors['green-90'] }, // green-90
  { country: 'Brazil', company: 'FABRICA DE VIAGEM', months: 6, color: theme.colors['green-90'] }, // green-90
  // USA
  { country: 'USA', company: 'American Luxury Travel', months: 11, color: theme.colors['booking-com-sky-blue'] }, // booking-com-sky-blue
  { country: 'USA', company: 'Prestige Journeys LLC', months: 9, color: theme.colors['booking-com-sky-blue'] }, // booking-com-sky-blue
  { country: 'USA', company: 'Elite Voyages Inc', months: 13, color: theme.colors['booking-com-sky-blue'] }, // booking-com-sky-blue
  { country: 'USA', company: 'Luxury Escapes USA', months: 7, color: theme.colors['booking-com-sky-blue'] }, // booking-com-sky-blue
  { country: 'USA', company: 'Premium Travel Partners', months: 17, color: theme.colors['booking-com-sky-blue'] }, // booking-com-sky-blue
  // UK
  { country: 'UK', company: 'British Luxury Holidays', months: 14, color: theme.colors['status-light-cancelled'] }, // status-light-cancelled
  { country: 'UK', company: 'Royal Travel Associates', months: 10, color: theme.colors['status-light-cancelled'] }, // status-light-cancelled
  { country: 'UK', company: 'London Premier Voyages', months: 12, color: theme.colors['status-light-cancelled'] }, // status-light-cancelled
  { country: 'UK', company: 'UK Elite Getaways', months: 8, color: theme.colors['status-light-cancelled'] }, // status-light-cancelled
  { country: 'UK', company: 'Westminster Travel Co', months: 19, color: theme.colors['status-light-cancelled'] }, // status-light-cancelled
  // France
  { country: 'France', company: 'Voyages de Luxe Paris', months: 15, color: theme.colors['purple-light'] }, // purple-light
  { country: 'France', company: 'French Riviera Travel', months: 11, color: theme.colors['purple-light'] }, // purple-light
  { country: 'France', company: 'Provence Elite Tours', months: 9, color: theme.colors['purple-light'] }, // purple-light
  { country: 'France', company: 'Paris Premium Escapes', months: 13, color: theme.colors['purple-light'] }, // purple-light
  { country: 'France', company: 'Côte d\'Azur Journeys', months: 16, color: theme.colors['purple-light'] }, // purple-light
  // Germany
  { country: 'Germany', company: 'Deutsche Luxury Reisen', months: 10, color: theme.colors['yellow-30'] }, // yellow-30
  { country: 'Germany', company: 'Berlin Elite Travel', months: 12, color: theme.colors['yellow-30'] }, // yellow-30
  { country: 'Germany', company: 'Munich Premium Tours', months: 7, color: theme.colors['yellow-30'] }, // yellow-30
  { country: 'Germany', company: 'Hamburg Prestige Voyages', months: 14, color: theme.colors['yellow-30'] }, // yellow-30
  { country: 'Germany', company: 'Frankfurt Travel Partners', months: 18, color: theme.colors['yellow-30'] }, // yellow-30
  // Spain
  { country: 'Spain', company: 'Barcelona Luxury Travel', months: 13, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Spain', company: 'Madrid Elite Journeys', months: 9, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Spain', company: 'Costa del Sol Escapes', months: 11, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Spain', company: 'Ibiza Premium Holidays', months: 15, color: theme.colors['inv-mango'] }, // inv-mango
  { country: 'Spain', company: 'Seville Prestige Tours', months: 8, color: theme.colors['inv-mango'] }, // inv-mango
];

// Mock data for conversion rate by sales rep
export const conversionRateData = [
  { rep: 'alex', low: 20, medium: 30, high: 50 },
  { rep: 'alex | alexandra', low: 25, medium: 35, high: 40 },
  { rep: 'alex | alexandra | nina', low: 30, medium: 40, high: 30 },
  { rep: 'alex | anastasia', low: 22, medium: 33, high: 45 },
  { rep: 'alex | anastasia | denis', low: 28, medium: 38, high: 34 },
  { rep: 'alex | denis | olga.m', low: 24, medium: 36, high: 40 },
  { rep: 'alex | alina', low: 26, medium: 34, high: 40 },
  { rep: 'alex | irina', low: 21, medium: 32, high: 47 },
  { rep: 'alex | irina | anca', low: 27, medium: 37, high: 36 },
  { rep: 'alex | kate', low: 23, medium: 35, high: 42 },
];

// Mock data for sales rep scatter plot
export const salesRepScatterData = [
  { enquiries: 20, bookings: 8 },
  { enquiries: 40, bookings: 18 },
  { enquiries: 60, bookings: 28 },
  { enquiries: 80, bookings: 40 },
  { enquiries: 100, bookings: 52 },
  { enquiries: 120, bookings: 65 },
  { enquiries: 150, bookings: 82 },
  { enquiries: 180, bookings: 100 },
  { enquiries: 200, bookings: 118 },
  { enquiries: 230, bookings: 138 },
  { enquiries: 260, bookings: 160 },
  { enquiries: 300, bookings: 188 },
  { enquiries: 330, bookings: 210 },
  { enquiries: 360, bookings: 235 },
  { enquiries: 400, bookings: 265 },
  { enquiries: 450, bookings: 305 },
  { enquiries: 480, bookings: 335 },
  { enquiries: 520, bookings: 365 },
];

// Mock data for bookings and guests by hotel
export const bookingsGuestsData = [
  { hotel: 'Ground Services UAE', bookings: 450, guests: 850 },
  { hotel: 'Waldorf Astoria Itha', bookings: 380, guests: 1950 },
  { hotel: 'Atlantis The Royal', bookings: 420, guests: 1850 },
  { hotel: 'One & Only Reethi', bookings: 350, guests: 1600 },
  { hotel: 'Joali Maldives', bookings: 320, guests: 1450 },
  { hotel: 'Vakkaru Maldives', bookings: 310, guests: 1420 },
  { hotel: 'Four Seasons Resort', bookings: 290, guests: 1350 },
  { hotel: 'Jumeirah Al Nasee', bookings: 250, guests: 1200 },
  { hotel: 'Constance Ephelia', bookings: 280, guests: 1500 },
];

// Mock data for treemap (average days of stay)
export const treemapData = [
  {
    name: 'Seychelles',
    children: [
      { name: 'Hotel A', size: 2800, days: 14 },
      { name: 'Hotel B', size: 2200, days: 12 },
      { name: 'Hotel C', size: 1800, days: 10 },
    ],
  },
  {
    name: 'South Africa',
    children: [
      { name: 'Hotel D', size: 3200, days: 18 },
      { name: 'Hotel E', size: 2600, days: 15 },
      { name: 'Hotel F', size: 2100, days: 13 },
      { name: 'Hotel G', size: 1900, days: 11 },
    ],
  },
  {
    name: 'UAE',
    children: [
      { name: 'Hotel H', size: 2400, days: 9 },
      { name: 'Hotel I', size: 2000, days: 7 },
      { name: 'Hotel J', size: 1600, days: 6 },
    ],
  },
];

// Mock data for Sales and Bookings by Month chart (comparing current vs previous year)
export const salesBookingsByMonthData = [
  { month: 'Jan', salesCurrentYear: 120, salesPreviousYear: 5, bookingsCurrentYear: 78, bookingsPreviousYear: 64 },
  { month: 'Feb', salesCurrentYear: 130, salesPreviousYear: 12, bookingsCurrentYear: 95, bookingsPreviousYear: 88 },
  { month: 'Mar', salesCurrentYear: 85, salesPreviousYear: 18, bookingsCurrentYear: 72, bookingsPreviousYear: 109 },
  { month: 'Apr', salesCurrentYear: 90, salesPreviousYear: 15, bookingsCurrentYear: 84, bookingsPreviousYear: 76 },
  { month: 'May', salesCurrentYear: 135, salesPreviousYear: 22, bookingsCurrentYear: 121, bookingsPreviousYear: 98 },
  { month: 'Jun', salesCurrentYear: 130, salesPreviousYear: 20, bookingsCurrentYear: 146, bookingsPreviousYear: 112 },
  { month: 'Jul', salesCurrentYear: 145, salesPreviousYear: 20, bookingsCurrentYear: 189, bookingsPreviousYear: 132 },
  { month: 'Aug', salesCurrentYear: 140, salesPreviousYear: 20, bookingsCurrentYear: 173, bookingsPreviousYear: 127 },
  { month: 'Sep', salesCurrentYear: 145, salesPreviousYear: 25, bookingsCurrentYear: 201, bookingsPreviousYear: 154 },
];
